import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Attach bearer token fallback for environments where third-party cookies are blocked
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ss_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-redirect to /root/admin/login whenever the stored admin token becomes invalid / expired.
// This avoids stale-session "Invalid token" toasts after a backend JWT_SECRET change.
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    const authRelated =
      status === 401 &&
      (detail === "Invalid token" ||
        detail === "Token expired" ||
        detail === "Not authenticated" ||
        detail === "Invalid token type" ||
        detail === "User not found");
    if (authRelated && typeof window !== "undefined") {
      try {
        localStorage.removeItem("ss_token");
      } catch (_) {}
      // Only redirect if we are inside the admin panel (avoid hijacking site calls).
      if (window.location.pathname.startsWith("/root/admin") && window.location.pathname !== "/root/admin/login") {
        window.location.replace("/root/admin/login");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
